<template>
  <div class="value-display">
    <div class="row">
      <div class="col-6 label">{{labelText}}</div>
      <div class="col-6 value">{{valueText}}</div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

const mappingFields = [['__consumer_phone__', 'phone1'],
  ['__consumer_name__', 'fullname'],
  ['__consumer_email__', 'email'],
  ['__consumer_firstname__', 'firstname'],
  ['__consumer_lastname__', 'lastname'],
  ['__agent_id__', 'agent_id'],
  ['__agent_name__', 'agent_name'],
  ['__call_center_dba__', 'call_center_dba'],
  ['__consumer_address__', 'address'],
  ['__consumer_city__', 'city'],
  ['__consumer_state__', 'state'],
  ['__consumer_zip__', 'zip']]

export default {
  name: 'ValueDisplay',
  props: ['label', 'value'],
  data () {
    return {
    }
  },
  computed: {
    valueText () {
      return this.value
    },
    labelText () {
      var label = this.label
      mappingFields.forEach((item) => {
        label = label.replace(new RegExp(item[0], 'g'), this.leadInfo[item[1]] ?? '')
      })
      return label
    },
    ...mapGetters({
      leadInfo: 'consumer/lead/leadInfo'
    })
  }
}
</script>
